import ProductMediaForm from './ProductMediaForm'

export default ProductMediaForm
